import { AlertProps, Elem, ElemBefore } from "@alm/flow-ds/components";
import {
	businessLogicPropertyType,
	BusinessLogicUpdateData,
	FormBusinessLogicUpdateDataValidation,
} from "hooks/FormDesigner/useElementList";
import { useTranslation } from "react-i18next";
import { businessLogicValue } from "schemas/elements";
import BusinessLogicItem from "./BusinessLogicItem";

type FormBusinessLogic = {
	beforeSave?: businessLogicValue;
	onLoad?: businessLogicValue;
};

type ElementBusinessLogic = businessLogicValue;

type Props = {
	value: FormBusinessLogic | ElementBusinessLogic;
	elementIndex: number;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	updateStore: (data: BusinessLogicUpdateData<any>) => void;
	required: boolean;
	id: string;
	validation: boolean;
	updateFormBusinessLogicValidation: (
		data: FormBusinessLogicUpdateDataValidation
	) => void;
	addAlert: (alert: string, status: AlertProps["status"]) => void;
	actions: businessLogicPropertyType[];
	desc: string;
};

export default ({
	required,
	elementIndex,
	value,
	actions,
	desc,
	...rest
}: Props) => {
	const { t } = useTranslation();

	return (
		<Elem className="elem-business-logic">
			<ElemBefore
				label={t("formDesigner.labels.businessLogic")}
				required={required}
			/>
			<div className="hint-text">
				{t(`formDesigner.elements.${desc}`)}
			</div>
			<div className="business-logic-list">
				{actions?.map((action: businessLogicPropertyType) => {
					const v =
						action !== "afterPatch"
							? (value as FormBusinessLogic)[action]
							: (value as ElementBusinessLogic);

					return (
						<BusinessLogicItem
							key={`${action}-${elementIndex}-item`}
							elementIndex={elementIndex}
							action={action}
							value={v}
							{...rest}
						/>
					);
				})}
			</div>
		</Elem>
	);
};
